import { API } from "../utils";

/* پرتال مشتری — API جدا از پنل. هر اندپوینت پنل روی این فرض بنا شده که کاربر
 * عضو سازمان است؛ اینجا مشتری و نماینده را میدل‌ور تعیین می‌کند. */

export const getPortalMe = async () => API.get("/portal/me");

export const getPortalDashboard = async () => API.get("/portal/dashboard");

export const getPortalProjects = async () => API.get("/portal/projects");

export const getPortalProject = async ({ params }) =>
  API.get(`/portal/projects/${params.uuid}`);

export const getPortalTask = async ({ params }) =>
  API.get(`/portal/tasks/${params.uuid}`);

export const getPortalTickets = async ({ params } = {}) =>
  API.get("/portal/tickets", { params });

export const getPortalTicket = async ({ params }) =>
  API.get(`/portal/tickets/${params.uuid}`);

export const createPortalTicket = async ({ body }) =>
  API.post("/portal/tickets", body);

export const replyPortalTicket = async ({ params, body }) =>
  API.post(`/portal/tickets/${params.uuid}/replies`, body);
